(() => {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];

  const menuToggle = $('[data-menu-toggle]');
  const mobileMenu = $('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      mobileMenu.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });
  }

  const revealItems = $$('.reveal');
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.11, rootMargin: '0px 0px -30px' });
    revealItems.forEach((item) => revealObserver.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  $$('[data-countdown]').forEach((clock) => {
    const deadline = new Date(clock.dataset.deadline).getTime();
    const label = $('[data-countdown-label]', clock);
    if (!Number.isFinite(deadline)) {
      clock.hidden = true;
      return;
    }
    let timer;
    const tick = () => {
      const distance = Math.max(0, deadline - Date.now());
      const values = {
        days: Math.floor(distance / 86400000),
        hours: Math.floor((distance % 86400000) / 3600000),
        minutes: Math.floor((distance % 3600000) / 60000),
        seconds: Math.floor((distance % 60000) / 1000)
      };
      Object.entries(values).forEach(([key, value]) => {
        const target = $(`[data-${key}]`, clock);
        if (target) target.textContent = String(value).padStart(2, '0');
      });
      if (distance === 0) {
        if (timer) window.clearInterval(timer);
        if (label) label.textContent = clock.dataset.expired || 'THE WORKSHOP IS OPEN';
      }
    };
    tick();
    timer = window.setInterval(tick, 1000);
  });

  const showToast = (message) => {
    const toast = $('#HHToast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => toast.classList.remove('is-visible'), 3200);
  };

  const formatMoney = (cents, currency = 'USD') => {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(Number(cents) / 100);
    } catch (_) {
      return `$${(Number(cents) / 100).toFixed(2)}`;
    }
  };

  const toHandle = (value = '') => String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  const shopRoot = window.Shopify?.routes?.root || '/';
  const shopRoute = (path) => `${shopRoot}${String(path).replace(/^\//, '')}`;
  const cartDrawerRoot = $('[data-cart-drawer-root]');
  const cartDrawer = cartDrawerRoot ? $('.cart-drawer', cartDrawerRoot) : null;
  let drawerReturnFocus = null;

  const updateCartCount = (cart) => {
    $$('[data-cart-count]').forEach((count) => {
      count.textContent = cart?.item_count || 0;
      const link = count.closest('[data-open-cart]');
      if (link) link.setAttribute('aria-label', `Open bag with ${cart?.item_count || 0} items`);
    });
  };

  const fetchCart = async () => {
    const response = await fetch(cartDrawerRoot?.dataset.cartUrl || shopRoute('cart.js'), {
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('Your bag could not be opened. Please try again.');
    return response.json();
  };

  const changeCartLine = async (key, quantity) => {
    const response = await fetch(shopRoute('cart/change.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity) || 0) })
    });
    const cart = await response.json();
    if (!response.ok) throw new Error(cart.description || 'That quantity could not be changed.');
    return cart;
  };

  const addLineToCart = async (form) => {
    const response = await fetch(shopRoute('cart/add.js'), {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'This piece could not be added.');
    return data;
  };

  const drawerImageFor = (item) => {
    const option = item.options_with_values?.[0]?.value || item.variant_title || '';
    const custom = cartDrawerRoot?.getAttribute(`data-image-${toHandle(option)}`);
    return custom || item.featured_image?.url || item.image || '';
  };

  const makeNode = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };

  const renderCartDrawer = (cart) => {
    if (!cartDrawerRoot) return;
    const items = $('[data-cart-drawer-items]', cartDrawerRoot);
    const empty = $('[data-cart-drawer-empty]', cartDrawerRoot);
    const footer = $('[data-cart-drawer-footer]', cartDrawerRoot);
    const subtotal = $('[data-cart-drawer-subtotal]', cartDrawerRoot);
    const currency = cart.currency || cartDrawerRoot.dataset.currency || document.body.dataset.currency || 'USD';
    items?.replaceChildren();
    updateCartCount(cart);
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price, currency);
    if (empty) empty.hidden = cart.item_count > 0;
    if (footer) footer.hidden = cart.item_count === 0;

    (cart.items || []).forEach((item) => {
      const article = makeNode('article', 'cart-drawer-item');
      const mediaLink = makeNode('a', 'cart-drawer-item__media');
      mediaLink.href = item.url || cartDrawerRoot.dataset.cartPageUrl || '/cart';
      const image = makeNode('img');
      image.src = drawerImageFor(item);
      image.alt = item.product_title || item.title || 'Selected product';
      image.width = 180;
      image.height = 180;
      image.loading = 'lazy';
      mediaLink.append(image);

      const content = makeNode('div', 'cart-drawer-item__content');
      const title = makeNode('a', 'cart-drawer-item__title', item.product_title || item.title);
      title.href = item.url || cartDrawerRoot.dataset.cartPageUrl || '/cart';
      const option = item.options_with_values?.[0]?.value || item.variant_title;
      const variant = makeNode('p', 'cart-drawer-item__variant', option && option !== 'Default Title' ? option : 'Seasonal edition');
      const controls = makeNode('div', 'cart-drawer-item__controls');
      const minus = makeNode('button', '', '−');
      minus.type = 'button';
      minus.setAttribute('aria-label', `Decrease quantity of ${item.product_title || item.title}`);
      minus.dataset.cartDrawerChange = item.key;
      minus.dataset.newQuantity = String(item.quantity - 1);
      const quantity = makeNode('span', '', String(item.quantity));
      quantity.setAttribute('aria-live', 'polite');
      const plus = makeNode('button', '', '+');
      plus.type = 'button';
      plus.setAttribute('aria-label', `Add another ${item.product_title || item.title}`);
      plus.dataset.cartDrawerChange = item.key;
      plus.dataset.newQuantity = String(item.quantity + 1);
      controls.append(minus, quantity, plus);
      const remove = makeNode('button', 'cart-drawer-item__remove', 'REMOVE');
      remove.type = 'button';
      remove.dataset.cartDrawerChange = item.key;
      remove.dataset.newQuantity = '0';
      content.append(title, variant, controls, remove);

      const linePrice = makeNode('b', 'cart-drawer-item__price', formatMoney(item.final_line_price, currency));
      article.append(mediaLink, content, linePrice);
      items?.append(article);
    });
  };

  const openCartDrawer = async (cart) => {
    if (!cartDrawerRoot || !cartDrawer) {
      window.location.assign(cartDrawerRoot?.dataset.cartPageUrl || shopRoute('cart'));
      return;
    }
    drawerReturnFocus = document.activeElement;
    const currentCart = cart || await fetchCart();
    renderCartDrawer(currentCart);
    cartDrawerRoot.classList.add('is-open');
    cartDrawerRoot.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    window.setTimeout(() => cartDrawer.focus(), 50);
  };

  const closeCartDrawer = () => {
    if (!cartDrawerRoot) return;
    cartDrawerRoot.classList.remove('is-open');
    cartDrawerRoot.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    if (drawerReturnFocus instanceof HTMLElement) drawerReturnFocus.focus();
  };

  $$('[data-open-cart]').forEach((link) => link.addEventListener('click', async (event) => {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    try { await openCartDrawer(); } catch (_) { window.location.assign(link.href); }
  }));
  $$('[data-cart-drawer-close]').forEach((button) => button.addEventListener('click', closeCartDrawer));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && cartDrawerRoot?.classList.contains('is-open')) closeCartDrawer();
  });
  cartDrawerRoot?.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-drawer-change]');
    if (!button) return;
    button.disabled = true;
    try {
      const cart = await changeCartLine(button.dataset.cartDrawerChange, button.dataset.newQuantity);
      renderCartDrawer(cart);
    } catch (error) {
      showToast(error.message);
      button.disabled = false;
    }
  });

  $$('[data-cart-page-change]').forEach((control) => control.addEventListener('click', async (event) => {
    event.preventDefault();
    if (control.getAttribute('aria-disabled') === 'true') return;
    control.setAttribute('aria-disabled', 'true');
    try {
      await changeCartLine(control.dataset.lineKey, control.dataset.newQuantity);
      window.location.reload();
    } catch (error) {
      control.removeAttribute('aria-disabled');
      showToast(error.message);
    }
  }));

  $$('[data-product-root]').forEach((root) => {
    const galleryPanels = $$('[data-media-id]', root);
    const galleryThumbs = $$('[data-gallery-thumb]', root);
    const activateMedia = (mediaId) => {
      if (!mediaId) return;
      galleryPanels.forEach((panel) => {
        const active = String(panel.dataset.mediaId) === String(mediaId);
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
      galleryThumbs.forEach((thumb) => thumb.classList.toggle('is-active', String(thumb.dataset.galleryThumb) === String(mediaId)));
    };
    galleryThumbs.forEach((thumb) => thumb.addEventListener('click', () => activateMedia(thumb.dataset.galleryThumb)));

    const fallbackPanel = $('[data-media-id="fallback-main"] img', root);
    $$('[data-fallback-image]', root).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        $$('[data-fallback-image]', root).forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (fallbackPanel) {
          fallbackPanel.src = thumb.dataset.fallbackImage;
          fallbackPanel.alt = $('img', thumb)?.alt || 'Product image';
        }
      });
    });

    const productDataNode = $('[data-product-json]', root);
    let variants = [];
    try { variants = productDataNode ? JSON.parse(productDataNode.textContent) : []; } catch (_) { variants = []; }
    const optionGroups = $$('[data-option-index]', root);
    const variantInput = $('[data-variant-id]', root);
    const price = $('[data-product-price]', root);
    const comparePrice = $('[data-compare-price]', root);
    const savePill = $('[data-save-pill]', root);
    const addButton = $('[data-add-button]', root);
    const addText = $('[data-add-text]', root);
    const buyNowButton = $('[data-buy-now]', root);
    const buyNowText = $('[data-buy-now-text]', root);
    const stickyPrice = $('[data-sticky-price]', root);
    const stickySubmit = $('[data-sticky-submit]', root);
    const dealCallout = $('[data-deal-callout]', root);
    const featuredVariant = root.dataset.featuredVariant || '';
    const currency = root.dataset.currency || document.body.dataset.currency || 'USD';

    const selectedOptions = () => optionGroups.map((group) => $('.option-button.is-selected', group)?.dataset.optionValue || '');
    const updateVariant = () => {
      if (!variants.length) return;
      const selected = selectedOptions();
      const variant = variants.find((candidate) => candidate.options.every((option, index) => option === selected[index]));
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (buyNowButton) buyNowButton.disabled = true;
        if (stickySubmit) stickySubmit.disabled = true;
        if (addText) addText.textContent = 'UNAVAILABLE';
        if (buyNowText) buyNowText.textContent = 'UNAVAILABLE';
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price, currency);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price, currency);
      const hasCompare = Number(variant.compare_at_price) > Number(variant.price);
      if (comparePrice) {
        comparePrice.hidden = !hasCompare;
        comparePrice.textContent = hasCompare ? formatMoney(variant.compare_at_price, currency) : '';
      }
      if (savePill) {
        savePill.hidden = !hasCompare;
        savePill.textContent = hasCompare ? `SAVE ${formatMoney(variant.compare_at_price - variant.price, currency)}` : '';
      }
      if (addButton) addButton.disabled = !variant.available;
      if (buyNowButton) buyNowButton.disabled = !variant.available;
      if (stickySubmit) stickySubmit.disabled = !variant.available;
      if (addText) addText.textContent = variant.available ? 'GET THE HALLOWLIGHT TREE' : 'SOLD OUT';
      if (buyNowText) buyNowText.textContent = variant.available ? 'BUY IT NOW — FAST CHECKOUT' : 'SOLD OUT';
      if (dealCallout) dealCallout.hidden = !variant.options.includes(featuredVariant);
      const variantVisual = $(`[data-gallery-variant="${toHandle(variant.options?.[0] || variant.title)}"]`, root);
      if (variantVisual) activateMedia(variantVisual.dataset.mediaId);
      else if (variant.featured_media?.id) activateMedia(variant.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    optionGroups.forEach((group) => {
      $$('.option-button', group).forEach((button) => {
        button.addEventListener('click', () => {
          $$('.option-button', group).forEach((item) => {
            const selected = item === button;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-pressed', String(selected));
          });
          const selectedLabel = $('[data-selected-option]', group);
          if (selectedLabel) selectedLabel.textContent = button.dataset.optionValue;
          updateVariant();
        });
      });
    });

    const quantityInput = $('[data-quantity-input]', root);
    $$('[data-bundle-qty]', root).forEach((button) => {
      button.addEventListener('click', () => {
        $$('[data-bundle-qty]', root).forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
        if (quantityInput) quantityInput.value = button.dataset.bundleQty;
      });
    });

    const form = $('[data-product-form]', root);
    if (form) {
      form.addEventListener('submit', async (event) => {
        if (event.submitter && event.submitter.name !== 'add') return;
        event.preventDefault();
        const error = $('[data-product-error]', form);
        if (addButton) addButton.disabled = true;
        if (addText) addText.textContent = 'ADDING TO YOUR BAG…';
        try {
          await addLineToCart(form);
          const cart = await fetchCart();
          if (error) error.hidden = true;
          if (addText) addText.textContent = 'ADDED TO YOUR BAG ✓';
          await openCartDrawer(cart);
          window.setTimeout(updateVariant, 1500);
        } catch (err) {
          if (error) { error.textContent = err.message; error.hidden = false; }
          if (addText) addText.textContent = 'TRY AGAIN';
          if (addButton) addButton.disabled = false;
        }
      });
    }

    if (buyNowButton && form) {
      buyNowButton.addEventListener('click', async () => {
        const error = $('[data-product-error]', form);
        buyNowButton.disabled = true;
        if (buyNowText) buyNowText.textContent = 'OPENING SECURE CHECKOUT…';
        try {
          await addLineToCart(form);
          window.location.assign(cartDrawerRoot?.dataset.checkoutUrl || '/checkout');
        } catch (err) {
          if (error) { error.textContent = err.message; error.hidden = false; }
          buyNowButton.disabled = false;
          if (buyNowText) buyNowText.textContent = 'TRY FAST CHECKOUT AGAIN';
        }
      });
    }

    if (stickySubmit && form) stickySubmit.addEventListener('click', () => form.requestSubmit(addButton));
    $$('[data-scroll-to-buy]', root).forEach((button) => button.addEventListener('click', () => form?.scrollIntoView({ behavior: 'smooth', block: 'center' })));

    const sticky = $('[data-sticky-buy]', root);
    const buybox = $('.product-buybox', root);
    if (sticky && buybox) {
      const setSticky = () => {
        const box = buybox.getBoundingClientRect();
        sticky.classList.toggle('is-visible', box.bottom < 80 && window.innerWidth <= 820);
      };
      window.addEventListener('scroll', setSticky, { passive: true });
      window.addEventListener('resize', setSticky);
      setSticky();
    }
  });

  const readingProgress = $('[data-reading-progress]');
  if (readingProgress) {
    const updateReadingProgress = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      const progress = scrollable > 0 ? Math.min(100, Math.max(0, window.scrollY / scrollable * 100)) : 0;
      readingProgress.style.width = `${progress}%`;
    };
    window.addEventListener('scroll', updateReadingProgress, { passive: true });
    updateReadingProgress();
  }
})();
